((CollectionBanner, $) => {
  'use strict';

  const hidden = 'collection-banner-item--hidden';

  let $bannerContainer;
  let $video;
  let $image;

  const cacheDom = () => {
    $bannerContainer = $('.js-collection-banner');
    $video = $bannerContainer.find('.js-collection-banner-video');
    $image = $bannerContainer.find('.js-collection-banner-image');
  };

  const setInitialState = () => {
    if ($(window).width() > 991) {
      $(document).on('ready', () => {
        $video[0].play();
      });
    } else {
      $video.addClass(hidden);
      $image.removeClass(hidden);
    }
  };

  const bindUIActions = () => {
    $(window).on('resize', function(){
      const width = $(this).width();

      if (width > 991) {
        $video.removeClass(hidden);
        if ($video[0].paused) {
          $video[0].play()
        }
      } else {
        $video.addClass(hidden);
        if (!$video[0].paused) {
          $video[0].pause();
        }
      }
    });
  };

  const init = () => {
    cacheDom();
    if ($video[0]) {
      setInitialState();
      bindUIActions();
    }
  };

  CollectionBanner.init = init;
})(window.CollectionBanner = window.CollectionBanner || {}, jQuery);
